import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'app/_services/notification.service';
import { SiteWorkersService } from 'app/_services/site-workers.service';

@Component({
  selector: 'choose-workers-modal',
  templateUrl: './choose-workers-modal.component.html',
})
export class ChooseWorkersModalComponent implements OnInit {
  @Input() site: any;

  public siteWorkers: any[] = [];
  public selectedWorkers: any[] = [];

  // pagination
  pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  // Sorting and Filtering
  defaultSortField = 'workerUser.skylarkUser.user.lastName';
  selectedSort = this.defaultSortField + ',asc';

  public isFilterLoading: boolean;
  private filters = [
    { key: 'company', value: '' },
    { key: 'firstName', value: '' },
    { key: 'lastName', value: '' },
  ];

  constructor(
    private activeModal: NgbActiveModal,
    private notificationService: NotificationService,
    private siteWorkersService: SiteWorkersService,
  ) { }

  ngOnInit() {
    this.resetPagination();
    this.setupPage();
  }

  private setupPage() {
    this.siteWorkersService.getAllWorkerForSiteWithFilters(this.site.id, this.pagination, undefined, this.filters).subscribe((data: any) => {
      this.siteWorkers = [];
      const ids = this.selectedWorkers.map(w => w.id);

      this.siteWorkers.push(...data.body.filter(w => !ids.includes(w.id)), ...this.selectedWorkers);

      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
      this.isFilterLoading = false;
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error retrieving worker list');
      this.isFilterLoading = false;
    });
  }

  // Handle Pagination
  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.setupPage();
  }

  public resetPagination() {
    this.pagination = {
      size: 5,
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public onSubmit() {
    this.activeModal.close(this.selectedWorkers);
  }

  public onFilterTextChanged(filterText: string, filterField: string){
    this.isFilterLoading = true;

    this.filters.find(filter => filter.key === filterField).value = filterText;

    this.goToFirstPage();
    this.setupPage();
  }
}
